module.exports = __webpack_public_path__ + "static/media/Twitter.2ebbc7a0.svg";